// aws-config-joborder-receipts.js
import AWS from 'aws-sdk';

const INVOICE_BUCKET_NAME = 'boaz-joborder-receipts';

const s3InvoicePDFUploader = new AWS.S3({
  accessKeyId: 'AKIAVXGA6A4K63CAIBYO', // Replace with the new user's Access Key ID
  secretAccessKey: 'LGIdeljQ6oiI3jVjZaXZhUQtf2Z2lD1fWawZ+kL1', // Replace with the new user's Secret Access Key
  region: 'ap-southeast-1' // Replace with your S3 bucket's region
});

export { s3InvoicePDFUploader, INVOICE_BUCKET_NAME };
